import { useEffect } from "react";
import "../styles/Pedido.css";

export default function Pedido() {
  useEffect(() => {
    const email = "pedidos@pinkcomics.org";
    const subject = "Solicitação de quadrinho";
    const body =
      "Olá, eu gostaria que vocês adicionassem o seguinte quadrinho: [seu quadrinho aqui]";

    const mailto =
      `mailto:${email}` +
      `?subject=${encodeURIComponent(subject)}` +
      `&body=${encodeURIComponent(body)}`;

    window.location.replace(mailto);
  }, []);

  return (
    <main className="pedido">
      <h1 className="pedido-title">Abrindo seu cliente de e-mail...</h1>
      <p className="pedido-description">
        Se nada acontecer, clique aqui: <a href={`mailto:pedidos@pinkcomics.org?subject=${encodeURIComponent("Solicitação de quadrinho")}&body=${encodeURIComponent("Olá, eu gostaria que vocês adicionassem o seguinte quadrinho: [seu quadrinho aqui]")}`}>Abrir e-mail</a>
      </p>
    </main>
  );
}
